export class Country {
    id?: string = "0"
    code: string;
    name: string;
    initials: string;
    gentile: string;
    officialName: string;
    constructor(
    ) { }
}